<template>
	<section class="critic-slider hideme">
			<div class="carousel slide carousel-fade" data-ride="carousel">
				<div class="carousel-inner">
					<div class="item" v-for="(slide, idx) in criticSliderContent" :class="{'active': idx == 0}">
						<div class="quote top"><img src="https://res.cloudinary.com/dwmmozjrb/image/upload/v1627709206/fsl/icon-quote-top.png" alt="quote"></div>
						<div class="critic-content">
							<p v-if="slide.text" class="critic-quote" style="text-align: center">{{slide.text}}</p>
							<div v-if="slide.image" class="critic-img" style="text-align: center"><img :src="exportImagePath(slide.image)" alt="The Shape of Water"></div>
						</div>
						<div class="quote bottom"><img src="https://res.cloudinary.com/dwmmozjrb/image/upload/v1627709206/fsl/icon-quote-bottom.png" alt="quote"></div>
						<div v-if="slide.author" class="byline">{{slide.author}}</div>
					</div>
				</div>
			</div>
	</section>
</template>

<script>
	export default {
		name:'critic-quote',
		props: {
			criticSliderContent: {
				required: false,
				type: Array
			}
		},
		data: function() {
			return {}
		},
		methods: {
			exportImagePath: function(data) {
				return require('../assets/' + data + '.png');
			}
		},
		mounted: function() {
		}
	}
</script>


// WEBPACK FOOTER //
// CriticQuote.vue?2347f42a